import React from 'react';
import I18N from '@leverege/i18n';
import { Theme, Toast, Dialogs } from '@leverege/ui-elements';

/**
 * Creates and installs the Theme Provider. This requires Molten to have a config
 * with theme : { theme, activeThemeId, useActiveTheme }. The theme should be the
 * css version of the theme. If the activeThemeId is supplied, it will be used if
 * NODE_ENV is 'development' or useActiveTheme is true.
 */
export default {
  id: 'molten.ThemeInit',
  sort: -10,
  createProvider: async (molten, ...children) => {
    const {
      theme: sTheme,
      appearanceProjectId,
      appearanceId,
      useActiveTheme,
      config
    } = molten.getConfig('theme');
    const theme = sTheme?.then ? (await sTheme).default : sTheme;
    let useTheme = theme;
    if ((appearanceProjectId != null || appearanceId != null) && !(useActiveTheme === false || useActiveTheme === 'false') && (useActiveTheme === true || useActiveTheme === 'true')) {
      const mod = await import(/* webpackChunkName: "active-theme" */'@leverege/ui-active-theme');
      const ActiveTheme = mod.default;
      useTheme = new ActiveTheme({
        altTheme: theme,
        appearanceProjectId,
        appearanceId,
        config
      });
    }
    if (useTheme == null) {
      // eslint-disable-next-line no-console
      console.error('Molten: Theme is null. Make sure the theme is supplied in config.theme.theme');
    }
    I18N.addIconDelegate({
      getIcon(key) {
        if (useTheme.resources) {
          let r = useTheme.resources('icon', key);
          if (r == null && key.startsWith('icon.')) {
            // If the i18n resource name starts with 'icon.' and we
            // didnt find it, do one more check against our resources without
            // the 'icon.' This allow resources in ui-builder to be specified
            // as 'delete', and not 'icon.delete'
            r = useTheme.resources('icon', key.substring(5));
          }
          return r;
        }
        return undefined;
      }
    });
    return /*#__PURE__*/React.createElement(Theme, {
      theme: useTheme
    }, ...children);
  },
  createSupportComponents: molten => {
    return [/*#__PURE__*/React.createElement(Toast, {
      key: 'theme.toast'
    }), /*#__PURE__*/React.createElement(Dialogs, {
      key: 'theme.dialogs'
    })];
  }
};